import '../scss/index.scss';  // Causes the styles to be loaded on the page
import { game } from './gameManager';


function main() {
    game.createElement(document.getElementById("game"));
}

window.addEventListener('load', main);
